import { connect } from 'react-redux'

import { AppState } from '../reducers'
import App from '../components/App'
import * as selectors from '../selectors'
import * as actions from '../actions'

const mapStateToProps = (state: AppState) => ({
	locale: selectors.getLocale(state),
	isScanning: selectors.getIsScanning(state),
	showPromotionalPage: state.ui.showPromotionalPage,
})

const mapDispatchToProps = {
	setLocale: actions.setLocale,
	stopScanning: actions.stopScanning,
	detectBarcode: actions.detectBarcode as any,
}

const ConnectedApp = connect(mapStateToProps, mapDispatchToProps)(App)

export type AppProps = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps

export default ConnectedApp
